import {DependencyList, useLayoutEffect, useRef} from 'react';

export function useStateChange<T extends DependencyList>(
  onChange: (prev: T) => void,
  inputs: T,
) {
  const previous = useRef(inputs);
  useLayoutEffect(() => {
    onChange(previous.current);
    previous.current = inputs;
  }, inputs);
}
